import { useRef, useState } from "react";
import { Button, CheckBox, Divider, FormInput } from "../components";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

import { ReactComponent as SuccessGreen } from "../assets/images/success_green.svg";

import styles from "./styles/productsSection.module.scss";
import { ResultBanner } from "../components/result_banner";
import { Constants } from "../keys/constants";
import Strings from "../strings/strings";

enum State {
  Form,
  Success,
}

export const ProductsSection = () => {
  const [stageState, setStageState] = useState<State>(State.Form);

  const renderStage = (stage: State) => {
    switch (stage) {
      case State.Form:
        return (
          <div className={styles.wrapper}>
            <ProductForm onClick={() => setStageState(State.Success)} />
          </div>
        );
      case State.Success:
        return (
          <div className={styles.wrapper}>
            <Success />
          </div>
        );
      default:
        return;
    }
  };

  return <>{renderStage(stageState)}</>;
};

const ProductForm: React.FC<{
  onClick?: () => void;
}> = ({ onClick }) => {
  const form = useRef<HTMLFormElement>(null);
  const [renderBanner, setRenderBanner] = useState({
    bannerType: "",
    bannertext: "",
    render: false,
  });
  const navigate = useNavigate();

  const sendEmail = (e: any) => {
    e.preventDefault();
    emailjs
      .sendForm(Constants.serviceKey, Constants.templateKeyProducts, form.current, {
        publicKey: Constants.publicKey,
      })
      .then(
        () => {
          setRenderBanner({
            bannertext: Strings.productsSuccess,
            bannerType: "success",
            render: true,
          });
          setTimeout(() => {
            setRenderBanner({
              bannertext: "",
              bannerType: "",
              render: false,
            });
          }, 3500);
          onClick();
          e.target.reset();
        },
        (error: any) => {
          setRenderBanner({
            bannertext: Strings.productsFail,
            bannerType: "failed",
            render: true,
          });
          setTimeout(() => {
            setRenderBanner({
              bannertext: "",
              bannerType: "",
              render: false,
            });
          }, 3500);
          console.warn("FAILED...", error.text);
        }
      );
  };

  return (
    <>
      {renderBanner.render === true
        ? ResultBanner({ text: renderBanner.bannertext, type: renderBanner.bannerType })
        : null}
      <div className={styles.stateWrapper}>
        <form ref={form} onSubmit={sendEmail} className={styles.form}>
          <div className={styles.sectionTitle}>{Strings.productsJoinListTitle}</div>
          <Divider width={"100%"} margin={0} />
          <span className={styles.title}>{Strings.productsJoinListSubtitle}</span>
          <div className={styles.checkBoxes}>
            {CheckBox({
              name: "face_mask",
              value: "",
              label: <span>{Strings.productsFaceMask}</span>,
            })}
            {CheckBox({
              name: "mobile_app",
              value: "",
              label: <span>{Strings.productsMobileApp}</span>,
            })}
          </div>
          {FormInput({
            label: Strings.productsFirstNameLabel,
            name: "name",
            placeholder: Strings.productsFirstNamePlaceholder,
            required: true,
          })}
          {FormInput({
            label: Strings.productsLastNameLabel,
            name: "lastname",
            placeholder: Strings.productsLastNamePlaceholder,
            required: true,
          })}
          {FormInput({
            label: Strings.productsEmailLabel,
            name: "email",
            type: "email",
            placeholder: Strings.productsEmailPlaceholder,
            required: true,
          })}
          <div className={styles.checkBoxes}>
            {CheckBox({
              required: true,
              name: "terms_and_conditions",
              value: "",
              label: (
                <span>
                  <span>{Strings.productsTncTitle} </span>
                  <span className={styles.link} onClick={() => navigate("/termsConditions")}>
                    {Strings.productsTncSubtitle}
                  </span>
                  <span className={styles.asterisk}>*</span>
                </span>
              ),
            })}

            {CheckBox({
              name: "marketing_consent",
              value: "marketing_consent",
              label: <span>{Strings.productsMarketing}</span>,
            })}
          </div>
          <Button text={Strings.productsConfirmBtn} type={"submit"} width={"100%"} />
        </form>
      </div>
    </>
  );
};

const Success: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.stateWrapperSuccess}>
        <span className={styles.title}>{Strings.productsSuccessTitle}</span>
        <div className={styles.successImage}>{/* <SuccessGreen /> */}</div>
        <span className={styles.successText}>{Strings.productsSuccessSubtitleOne}</span>
        <div className={styles.keepExploringBtn}>
          <Button
            text={Strings.productsSuccessButton}
            width={"100%"}
            type="submit"
            onClick={() => navigate("/")}
          />
        </div>
      </div>
    </>
  );
};
